<mat-tab-group class="full-height easy-tab-group" mat-align-tabs="start" [selectedIndex]="selectedIndex">
  <mat-tab label="{{ 'settings.user_profile_txt' | translate }}">
    <section class="tab-content">
      <dp-user-profile></dp-user-profile>
    </section>
  </mat-tab>
  <mat-tab label="{{ 'common.notifications_txt' | translate }}" *ngIf="!isUserPlus">
    <section class="tab-content">
      <dp-user-notification></dp-user-notification>
    </section>
  </mat-tab>
</mat-tab-group>
